function useClasses(styles: any, classes: Record<string, any>) {
    return Object.keys(classes)
        .filter(key => !!classes[key])
        .map(key => styles[key])
        .join(' ');
}

export default useClasses;
